import IMessageLogo from '@/assets/images/channels/imessage.png';
import {
  type BaseModalFCProps,
  type ModalFC,
} from '@/components/modals/modalsManager';
import { ChannelConnectModal } from '@/features/msg-channels/common/ChannelConnectModal';
import { MessagingChannelTypes } from '@/features/msg-channels/common/msg-channels.types';

export type IMessageChannelConnectModalProps = BaseModalFCProps & {
  currentIdentifier?: string | null;
};

export const IMessageChannelConnectModal: ModalFC<
  IMessageChannelConnectModalProps
> = (props) => (
  <ChannelConnectModal
    {...props}
    channelType={MessagingChannelTypes.IMESSAGE}
    channelName="iMessage"
    channelIconSrc={IMessageLogo}
    openButtonLabel="Open in Messages"
  />
);
